import {Alert} from 'react-bootstrap';

function Error(error){
 return(
    <Alert variant="danger">
        {error}
    </Alert>
 )
}

export default Error;